import { render, staticRenderFns } from "./NewProductSystemWizard.vue?vue&type=template&id=6bcda5cc&scoped=true"
import script from "./NewProductSystemWizard.vue?vue&type=script&lang=ts"
export * from "./NewProductSystemWizard.vue?vue&type=script&lang=ts"
import style0 from "./NewProductSystemWizard.vue?vue&type=style&index=0&id=6bcda5cc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6bcda5cc",
  null
  
)

export default component.exports